import React from 'react';
import { Link } from 'react-router-dom';
import Header from "./landing/Header"
import Footer from './landing/Footer';
import ShieldCheckIcon from '@heroicons/react/24/solid/ShieldCheckIcon';

import CurrencyDollarIcon from '@heroicons/react/24/solid/CurrencyDollarIcon';
import { CheckCircle, Brain, CreditCard, } from 'lucide-react';


const Costs = () => {
  return (
    <>

      <Header />
    <div className="min-h-screen bg-gray-50 container max-w-7xl px-4 mx-auto">
     
      {/* Pricing Cards */}
      <div className="container mx-auto px-4 pt-10 ">
        {/* Medicare & Insurance Rebates Section */}
      <div className="mb-12 text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Medicare & Insurance <span className="text-blue-600">Rebates</span>
        </h1>
        <p className="text-gray-500 text-base">
          Comprehensive breakdown of costs and rebates for ADHD assessment and ongoing care
        </p>
      </div>
        <div className="grid md:grid-cols-2 gap-8 max-w-7xl mx-auto">
          {/* ADHD Assessment Card */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200">
            <div className="bg-blue-600 p-6">
              <div className="flex justify-between items-center">
                <h3 className="text-2xl font-bold text-white">ADHD Assessment</h3>
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <p className="text-blue-100 mt-2">Complete diagnostic package</p>
            </div>
            
            <div className="p-6">
              <div className="text-center mb-8">
                <p className="text-4xl font-bold text-gray-900">$1,399</p>
                <p className="text-gray-600">Total cost</p>
              </div>

              <div className="space-y-4">
                <div className="flex justify-between items-center text-sm bg-green-50">
                  <span className="text-success">Medicare rebate</span>
                  <span className="text-success font-medium">-$384</span>
                </div>
                <div className="flex justify-between items-center text-sm bg-purple-50">
                  <span className="text-purple-600">Private insurance (typical)</span>
                  <span className="text-purple-600 font-medium">-$540 to $765</span>
                </div>
                <div className="border-t border-gray-200 pt-4 mt-4">
                  <div className="flex justify-between items-center ">
                    <span className="font-medium text-gray-900">Your cost after rebates:</span>
                    <span className="text-xl font-bold text-green-400">$630 - $475</span>
                  </div>
                  <p className="text-xs text-gray-500 mt-2">
                    With Medicare only: $1,015 • With Medicare + insurance: $630-$475
                  </p>
                </div>
              </div>

              
            </div>
          </div>

          {/* Monthly Monitoring Card */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200">
            <div className="bg-success p-6">
              <div className="flex justify-between items-center">
                <h3 className="text-2xl font-bold text-white">Monthly Monitoring</h3>
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <p className="text-green-100 mt-2">Ongoing care & support</p>
            </div>
            
            <div className="p-6">
              <div className="text-center mb-8">
                <p className="text-4xl font-bold text-success">$0</p>
                <p className="text-gray-600">Cost to you</p>
              </div>

              <div className="space-y-4">
                <div className="flex justify-between items-center text-sm bg-blue-50">
                  <span className="text-blue-600">Service value</span>
                  <span className="text-blue-600 font-medium">$129.95</span>
                </div>
                <div className="flex justify-between items-center text-sm bg-green-50">
                  <span className="text-success">Medicare bulk billing</span>
                  <span className="text-success font-medium">-$129.95</span>
                </div>
                <div className="border-t border-gray-200 pt-4 mt-4">
                  <div className="flex justify-between items-center">
                    <span className="font-medium text-gray-900">Your monthly cost:</span>
                    <span className="text-2xl font-bold text-success">$0</span>
                  </div>
                  <p className="text-xs text-gray-500 mt-2">
                    Completely free for all Medicare cardholders
                  </p>
                </div>
              </div>

             
            </div>
          </div>
        </div>
      </div>

      {/* Real Patient Examples */}
      <div className=" py-16 px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Real Patient Examples</h2>
          <p className="text-gray-500 text-base">See what other patients actually paid</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {[
            {
              name: 'Sarah, 28',
              coverage: 'Medicare + Medibank Private',
              cost: '$1,399',
              medicare: '-$384',
              insurance: '-$765',
              paid: '$250',
              iconColor: 'text-blue-600',
            },
            {
              name: 'Michael, 35',
              coverage: 'Medicare + HCF',
              cost: '$1,399',
              medicare: '-$384',
              insurance: '-$540',
              paid: '$475',
              iconColor: 'text-blue-600',
            },
            {
              name: 'Emma, 24',
              coverage: 'Medicare only',
              cost: '$1,399',
              medicare: '-$384',
              insurance: '$0',
              paid: '$1,015',
              iconColor: 'text-blue-600',
            },
          ].map((p, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm p-6 border border-gray-200">
              <div className="flex flex-col items-center text-center mb-4">
                <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center">
                  <svg className={`w-6 h-6 ${p.iconColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <h3 className="font-semibold text-gray-900 mt-3">{p.name}</h3>
                <p className="text-sm text-gray-500">{p.coverage}</p>
              </div>

              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-700">Assessment cost:</span>
                  <span className="font-medium text-gray-900">{p.cost}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-success">Medicare rebate:</span>
                  <span className="text-success font-medium">{p.medicare}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-purple-600">Insurance rebate:</span>
                  <span className="text-purple-600 font-medium">{p.insurance}</span>
                </div>
                <hr className="my-2" />
                <div className="flex justify-between font-semibold">
                  <span className="text-gray-900">{p.name.split(',')[0]} paid:</span>
                  <span className="text-success">{p.paid}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>


      <div className=" px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900">How Rebates Work</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-7xl mx-auto">
          {/* Medicare Rebate */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center mb-4">
              <div className="w-8 h-8  rounded-full flex items-center justify-center">
                <ShieldCheckIcon className="w-5 h-5 text-success" />
              </div>
              <h3 className="ml-3 font-semibold text-gray-900">Medicare Rebate</h3>
            </div>
            <ul className="space-y-2 text-sm text-gray-800">
              {[
                '$384 rebate for all Medicare cardholders',
                'Processed automatically after consultation',
                'Usually received within 1–2 weeks',
                'No paperwork required from you',
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 mt-0.5 text-success" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Private Insurance */}
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center mb-4">
              <div className="w-8 h-8  rounded-full flex items-center justify-center">
                <CreditCard className="w-5 h-5 text-purple-600" />
              </div>
              <h3 className="ml-3 font-semibold text-gray-900">Private Insurance</h3>
            </div>
            <ul className="space-y-2 text-sm text-gray-800">
              {[
                '$540–$765 typical rebate range',
                'Depends on your level of cover',
                'We provide all required forms',
                'Submit claim after consultation',
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-2">
                  <CheckCircle className="w-4 h-4 mt-0.5 text-purple-600" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className=" py-16 px-4">
        {/* Payment Options */}
        <div className="max-w-7xl mx-auto mb-16">
          <h2 className="text-2xl font-bold text-center text-gray-900 mb-10">Payment Options</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {/* Pay in Full */}
            <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 shadow-sm">
              <div className="flex items-center gap-3 mb-4">
                <CheckCircle className="w-6 h-6 text-blue-600" />
                <h3 className="font-semibold text-blue-900">Pay in Full</h3>
              </div>
              <div className="text-3xl font-bold text-blue-900 mb-2">$1,399</div>
              <p className="text-sm text-blue-800 mb-4">One payment, then claim your rebates</p>
              <ul className="space-y-2 text-sm text-blue-900">
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-4 h-4 text-blue-600" />
                  Credit card or bank transfer
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-4 h-4 text-blue-600" />
                  Immediate booking confirmation
                </li>
              </ul>
            </div>

            {/* Afterpay */}
            <div className="bg-green-100 border border-green-200 rounded-xl p-6 shadow-sm">
              <div className="flex items-center gap-3 mb-4">
                <CurrencyDollarIcon className="w-6 h-6 text-success" />
                <h3 className="font-semibold text-green-700">Afterpay</h3>
              </div>
              <div className="text-3xl font-bold text-success mb-2">4 × $350</div>
              <p className="text-sm text-green-800 mb-4">Split into 4 fortnightly payments</p>
              <ul className="space-y-2 text-sm text-green-700">
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-4 h-4 text-green-700" />
                  No interest or fees
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle className="w-4 h-4 text-green-700" />
                  Instant approval available
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Questions Section */}
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl font-bold text-center text-gray-900 mb-10">Questions?</h2>
          <div className="grid md:grid-cols-2 gap-4">
            {[
              {
                q: '“Do I need private insurance to get treatment?”',
                a: 'No – Medicare rebate alone reduces your cost to $1,015, and monthly monitoring is completely free.',
              },
              {
                q: '“Can I use Afterpay for the initial payment?”',
                a: 'Yes – 4 payments of $350 with no interest.',
              },
              {
                q: '“What if my insurance claim is rejected?”',
                a: 'We provide all correct documentation. If there are issues, our team will help resolve them.',
              },
              {
                q: '“Is the monthly monitoring really free forever?”',
                a: 'Yes – as long as you have Medicare and continue treatment, there’s no cost for monthly monitoring.',
              },
            ].map((item, idx) => (
              <div key={idx} className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
                <p className="font-medium text-gray-900 mb-2">{item.q}</p>
                <p className="text-sm text-gray-600">{item.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="bg-gradient-to-r from-blue-600 to-blue-400 text-white text-center rounded-xl px-6 py-12 xontainer mx-auto max-w-7xl mb-10">
        <h2 className="text-2xl font-bold mb-2">Ready to get started?</h2>
        <p className="text-base mb-6">
          Book your assessment and take the first step toward fast, affordable ADHD diagnosis.
        </p>
        <button className="bg-white text-blue-700 font-semibold px-6 py-2 rounded-md hover:bg-gray-100 transition">
          Start Your Assessment
        </button>
      </div>

    </div>
    <Footer/>
</>
  );
};

export default Costs; 